import axios from "axios";
import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {EQCompanyData} from "../../models/serverModels/EQCompanyData";
import {EQWorkOrder, WorkOrderListParams} from "../../models/serverModels/workOrder/EQWorkOrder";

const rootApi = process.env.REACT_APP_API_KEY;

const workOrder = axios.create({
  baseURL: rootApi,
});

export const processWorkOrder = async (
  params: Params.Update<EQWorkOrder>
): Promise<ResponseItem<EQWorkOrder>> =>
  workOrder({
    url: `/ProcessWorkOrder`,
    method: "put",
    data: params,
  }).then((res) => res.data);
export const rejectWorkOrder = async (
  params: Params.Update<EQWorkOrder>
): Promise<ResponseItem<EQWorkOrder>> =>
  workOrder({
    url: `/RejectWorkOrder`,
    method: "put",
    data: params,
  }).then((res) => res.data);
export const delayWorkOrder = async (
  params: Params.Update<EQWorkOrder>
): Promise<ResponseItem<EQWorkOrder>> =>
  workOrder({
    url: `/DelayWorkOrder`,
    method: "put",
    data: params,
  }).then((res) => res.data);
export const completeWorkOrder = async (
  params: Params.Update<EQWorkOrder>
): Promise<ResponseItem<EQWorkOrder>> =>
  workOrder({
    url: `/CompleteWorkOrder`,
    method: "put",
    data: params,
  }).then((res) => res.data);
